(() => {
  const mobile = window.matchMedia('(max-width: 767px)');
  const init = () => {
    document.querySelectorAll('[data-neb-footer-menu]').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.open = !mobile.matches;
      menu.querySelector('summary').addEventListener('click', event => {
        if (!mobile.matches) event.preventDefault();
      });
    });
  };
  mobile.addEventListener('change', () => {
    document.querySelectorAll('[data-neb-footer-menu]').forEach(menu => { menu.open = !mobile.matches; });
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
